import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn, Eye, EyeOff } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role === "admin") nav("/admin");
      else toast.error("Only administrators can access this panel.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-primary to-brand-primary-hover px-4">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, white 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8 text-white">
          <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center text-brand-primary font-serif font-bold text-lg mx-auto mb-4 shadow-lg">GOS</div>
          <h1 className="font-serif text-2xl font-bold">Admin Login</h1>
          <p className="text-white/80 mt-1 text-sm">Ghaziabad Ophthalmological Society</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl space-y-5">
          <div>
            <label className="form-label">Email Address</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" data-testid="login-email" />
          </div>
          <div>
            <label className="form-label">Password</label>
            <div className="relative">
              <input required type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="form-input pr-10" data-testid="login-password" />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-muted">
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <button disabled={busy} type="submit" className="btn-primary w-full" data-testid="login-submit">
            <LogIn size={16} /> {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="text-center mt-6 text-xs text-white/70">
          Restricted area · Authorized personnel only
        </div>
      </div>
    </div>
  );
}
